/*
 * Copyright The OpenTelemetry Authors
 * SPDX-License-Identifier: Apache-2.0
 */

import type { Attributes, AttributeValue } from '../common/Attributes';

/**
 * @deprecated please use {@link Attributes}
 * @since 1.0.0
 */
export type SpanAttributes = Attributes;

/**
 * @deprecated please use {@link AttributeValue}
 * @since 1.0.0
 */
export type SpanAttributeValue = AttributeValue;
